var _style, _circle, _circle2, _circle3, _ellipse, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _ellipse2, _path, _circle14, _circle15, _ellipse3, _ellipse4, _circle16, _circle17, _ellipse5, _ellipse6, _ellipse7, _circle18, _path2, _path3, _circle19, _circle20, _circle21, _path4, _path5, _ellipse8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSlimIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FBC02D;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 113.5,
    cy: 276.4,
    r: 24.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 297.3,
    cy: 276.4,
    r: 24.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 205.4,
    cy: 276.4,
    r: 47.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1602 0.1602 0.9871 -26.9034 35.2963)",
    className: "st0",
    cx: 205.4,
    cy: 184.5,
    rx: 24.5,
    ry: 24.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 205.4,
    cy: 368.3,
    r: 24.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 140.4,
    cy: 341.4,
    r: 24.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 270.4,
    cy: 211.4,
    r: 24.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 140.4,
    cy: 211.4,
    r: 24.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 270.4,
    cy: 341.4,
    r: 24.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 26.6,
    cy: 276.4,
    r: 18.7
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 402.2,
    cy: 278.8,
    r: 18.7
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 226.3,
    cy: 97.7,
    r: 18.7
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 205.4,
    cy: 455.2,
    r: 18.7
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 79,
    cy: 150,
    r: 18.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -118.9895 665.8515)",
    className: "st0",
    cx: 331.8,
    cy: 402.9,
    rx: 18.7,
    ry: 18.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M413.3,149.4c6.1-6.1,6.1-16,0-22.1c-6.1-6.1-16-6.1-22.1,0s-6.1,16,0,22.1c0,0,0,0,0,0 C397.3,155.5,407.2,155.5,413.3,149.4z"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 79,
    cy: 402.9,
    r: 18.7
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 77.4,
    cy: 329.3,
    r: 20.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6081 -0.7939 0.7939 0.6081 -22.5784 365.0222)",
    className: "st0",
    cx: 358.4,
    cy: 205.4,
    rx: 20.1,
    ry: 20.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6634 -0.7483 0.7483 0.6634 -59.7986 163.9979)",
    className: "st0",
    cx: 152.4,
    cy: 148.5,
    rx: 20.1,
    ry: 20.1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 258.4,
    cy: 404.3,
    r: 20.1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 152.4,
    cy: 404.4,
    r: 20.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -32.112 126.125)",
    className: "st0",
    cx: 301,
    cy: 143.8,
    rx: 20.1,
    ry: 20.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6526 -0.7577 0.7577 0.6526 -142.4017 136.295)",
    className: "st0",
    cx: 77.4,
    cy: 223.4,
    rx: 20.1,
    ry: 20.1
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2118 -0.9773 0.9773 0.2118 -59.2152 585.5272)",
    className: "st0",
    cx: 333.4,
    cy: 329.5,
    rx: 20.1,
    ry: 20.1
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 133.8,
    cy: 103.6,
    r: 10.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M505.2,99.7c-2.1-5.2-8.1-7.7-13.3-5.6c-5.2,2.1-7.7,8.1-5.6,13.3c2.1,5.2,8.1,7.7,13.3,5.6c0,0,0,0,0.1,0 C504.9,110.8,507.4,104.9,505.2,99.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.1,439.8c-5.2,2.1-7.7,8.1-5.6,13.3c2.1,5.2,8.1,7.7,13.3,5.6c5.2-2.1,7.7-8.1,5.6-13.3c0,0,0,0,0,0 C284.2,440.2,278.3,437.7,273.1,439.8z"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32.6,
    cy: 348.1,
    r: 10.2
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 133.9,
    cy: 449.2,
    r: 10.2
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32.6,
    cy: 204.8,
    r: 10.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M417,348.8c-5.2-2.2-11.2,0.3-13.3,5.5s0.3,11.2,5.5,13.3c5.2,2.2,11.2-0.3,13.3-5.5c0,0,0,0,0-0.1 C424.7,356.9,422.2,351,417,348.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.1,91.9c5.2-2.1,7.7-8.1,5.6-13.3c-2.1-5.2-8.1-7.7-13.3-5.6c-5.2,2.1-7.7,8.1-5.6,13.3c0,0,0,0,0,0.1 C319,91.5,324.9,94,330.1,91.9z"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.500928e-02 -0.9999 0.9999 1.500928e-02 227.1866 623.016)",
    className: "st0",
    cx: 429.8,
    cy: 196.2,
    rx: 10.2,
    ry: 10.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSlimIcon);
export default __webpack_public_path__ + "static/media/logo-slim-icon.7adda8c7d76399aa8a0896fa7f70fdaf.svg";
export { ForwardRef as ReactComponent };